import PropTypes from 'prop-types'
import React from 'react'
import Svg from 'react-svg'
import LoadSpinner from '../../../assets/svg/button-save-spiner.svg'

const Button = ({ disabled, type, loading, classButton, label, style, handleClick }) => (
  <button style={style} type={type} disabled={disabled || loading} className={`btn ${classButton}`} onClick={onClickButton(handleClick)}>
    {loading ? (
      <Svg className="save-load-spinner" path={LoadSpinner} />
    ) : (
      label
    )}
  </button>
)

const onClickButton = handler => e => {
  return handler ? handler(e) : {};
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  classButton: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button'])
}

Button.defaultProps = {
  type: 'submit'
}

export default Button



// WEBPACK FOOTER //
// ./src/shared/component/button/Button.jsx